import React from 'react';
import styles from './AcfFieldset.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { FieldSet } from '@/components';

let cx = className.bind(styles);

export default function AcfFieldset(props) {
	const { attributes, innerBlocks, fieldset } = props;
	const className = attributes.className?.split(' ') || [];

	function InnerBlocks() {
		return React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] });
	}
	return (
		<FieldSet id={attributes.anchor} className={cx([attributes.alignForm && `align-${attributes.alignForm}`, ...className])} disabled={fieldset.disabled} legend={fieldset.legend}>
			<InnerBlocks />
		</FieldSet>
	);
}

AcfFieldset.fragments = {
	key: `AcfFieldsetFragment`,
	entry: gql`
		fragment AcfFieldsetFragment on AcfFieldset {
			attributes {
				anchor
				className
				alignForm: align
			}
			fieldset {
				legend
				disabled
			}
		}
	`,
};

AcfFieldset.config = {
	name: 'AcfFieldset',
};
AcfFieldset.displayName = 'AcfFieldset';
